import axios from 'axios';
import { ProductItem } from 'types';

export const fetchProducts = (brandId: number) => {
  return axios.get<ProductItem[]>(`/api/brands/${brandId}/products`);
};
